import { FunctionComponent, memo } from "react";
import { faExternalLinkAlt } from "@fortawesome/pro-solid-svg-icons";
import { trackUser } from "utilities/track-user";
import { IProps } from "./external-interaction-link.types";
import { EllipsisMenuItem } from "@edgetier/client-components";
import "./external-interaction-link.scss";

/**
 * A link that, when clicked, will take the user to the external interaction.
 * @param props.interactionId The ID of the interaction.
 * @param props.url           The URL of the external interaction.
 */
const ExternalInteractionLink: FunctionComponent<IProps> = ({ interactionId, url }) => (
    <EllipsisMenuItem icon={faExternalLinkAlt}>
        <a
            className="external-interaction-link"
            href={url}
            rel="noopener noreferrer"
            target="_blank"
            onClick={() => trackUser("View Interaction Externally", { interactionId }, true)}
        >
            View external interaction
        </a>
    </EllipsisMenuItem>
);

export default memo(ExternalInteractionLink);
